import i18next from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';

import DeepsightFiltersButton from '@orders/components/FilterButton';

export const RoleModalFilterButton = (props) => {
  const { filtersState, columnsFilterList } = props;

  const {
    filters,
    setFilters,
    applyFilters,
    setApplyFilters,
    advancedFilters,
    setAdvancedFilters,
  } = filtersState;

  if (!columnsFilterList?.length) {
    return null;
  }

  return (
    <DeepsightFiltersButton
      advancedFilters={advancedFilters}
      applyFilters={applyFilters}
      columnsFilterList={columnsFilterList}
      filters={filters}
      setAdvancedFilters={setAdvancedFilters}
      setApplyFilters={setApplyFilters}
      setFilters={setFilters}
      textFilterButton={i18next.t('GENERAL.LIST_VIEW_FILTER_BUTTON')}
    />
  );
};

RoleModalFilterButton.propTypes = {
  filtersState: PropTypes.shape({
    filters: PropTypes.any,
    setFilters: PropTypes.func.isRequired,
    applyFilters: PropTypes.bool.isRequired,
    setApplyFilters: PropTypes.func.isRequired,
    advancedFilters: PropTypes.any,
    setAdvancedFilters: PropTypes.func.isRequired,
  }).isRequired,
  columnsFilterList: PropTypes.array,
};

export default RoleModalFilterButton;
